import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06919212"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content user_position font" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
    key: 0,
    class: "content total_amount"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "content user_position font" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 0,
    class: "content total_amount"
};
const _hoisted_10 = ["onClick"];
import { useStore } from '@/store/store';
import { decimalize, decimalizeByExchange, decimalizeByAny } from '@/logics/utils';
import { toRefs, computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        trade: null,
        list: null,
        reverse: { type: Boolean, default: false },
        showTotal: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const { list } = toRefs(props);
        const store = useStore();
        const userAgent = window.navigator.userAgent.toLowerCase();
        const isChrome = userAgent.indexOf('chrome') !== -1;
        const onClickPrice = (price) => {
            store.state.order.price = Number(String(decimalize(price, store.getters.symbol.quote, store.state.currencyInfo)).replaceAll(',', ''));
        };
        const onClickAmount = (amount) => {
            store.state.order.amount = Number(String(decimalize(amount, store.getters.symbol.base, store.state.currencyInfo)).replaceAll(',', ''));
        };
        const onClickTotal = (price, amount) => {
            store.state.order.price = Number(String(decimalize(price, store.getters.symbol.quote, store.state.currencyInfo)).replaceAll(',', ''));
            store.state.order.amount = Number(String(decimalize(amount, store.getters.symbol.base, store.state.currencyInfo)).replaceAll(',', ''));
        };
        const sellListClass = computed(() => {
            if (props.trade === 'sell' && store.state.isSmartPhone) {
                return 'reverse';
            }
            if (props.trade === 'sell') {
                return 'bottom_up';
            }
            if (props.trade === 'buy') {
                return 'top';
            }
            return '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (!props.reverse)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(_unref(sellListClass))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["list", item.trade]),
                                key: index,
                                style: _normalizeStyle(item.css)
                            }, [
                                _createElementVNode("div", _hoisted_1, [
                                    _withDirectives(_createElementVNode("label", null, "P", 512), [
                                        [_vShow, item.isMyPosition]
                                    ])
                                ]),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["content price font", isChrome ? 'chrome' : 'other']),
                                    onClick: ($event) => (onClickPrice(item.price))
                                }, _toDisplayString(_unref(decimalizeByExchange)(item.price, _unref(store).getters.symbol.pair, _unref(store).state.currencyPairInfo)), 11, _hoisted_2),
                                (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["content amount font", `move_${item.animation}`]),
                                    key: `${item.animation}_${index}`,
                                    onClick: ($event) => (onClickAmount(item.size))
                                }, _toDisplayString(_unref(decimalizeByAny)(item.size, _unref(store).getters.symbol.base, _unref(store).state.currencyInfo)), 11, _hoisted_3)),
                                (props.showTotal)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        (_openBlock(), _createElementBlock("div", {
                                            class: "total_amount_inner font",
                                            onClick: ($event) => (onClickTotal(item.price, Number(item.total))),
                                            key: item.css
                                        }, _toDisplayString(_unref(decimalizeByAny)(Number(item.total), _unref(store).getters.symbol.base, _unref(store).state.currencyInfo)), 9, _hoisted_5))
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 6));
                        }), 128))
                    ], 2))
                    : _createCommentVNode("", true),
                (props.reverse)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(_unref(sellListClass))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["list", item.trade]),
                                key: index,
                                style: _normalizeStyle(item.css)
                            }, [
                                (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["content amount font amount_left", `move_${item.animation}`]),
                                    key: `${item.animation}_${index}`,
                                    onClick: ($event) => (onClickAmount(item.size))
                                }, _toDisplayString(_unref(decimalizeByAny)(item.size, _unref(store).getters.symbol.base, _unref(store).state.currencyInfo)), 11, _hoisted_6)),
                                _createElementVNode("div", _hoisted_7, [
                                    _withDirectives(_createElementVNode("label", null, "P", 512), [
                                        [_vShow, item.isMyPosition]
                                    ])
                                ]),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["content price font", isChrome ? 'chrome' : 'other']),
                                    onClick: ($event) => (onClickPrice(item.price))
                                }, _toDisplayString(_unref(decimalizeByExchange)(item.price, _unref(store).getters.symbol.pair, _unref(store).state.currencyPairInfo)), 11, _hoisted_8),
                                (props.showTotal)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        (_openBlock(), _createElementBlock("div", {
                                            class: "total_amount_inner font",
                                            onClick: ($event) => (onClickTotal(item.price, Number(item.total))),
                                            key: item.css
                                        }, _toDisplayString(_unref(decimalizeByAny)(Number(item.total), _unref(store).getters.symbol.base, _unref(store).state.currencyInfo)), 9, _hoisted_10))
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 6));
                        }), 128))
                    ], 2))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
